// extracted by mini-css-extract-plugin
export default {"footer":"UnQvK1X9xWIZIOa1PLdO"};